import applyPolyfills from "./element";

describe("Element polyfills", () => {
    it("polyfills Element.matches", () => {
        applyPolyfills();
        const { matches } = Element.prototype;
        const MockElement = Object.getPrototypeOf(Element);
        MockElement.prototype.webkitMatchesSelector = matches;
        delete MockElement.prototype.matches;
        delete Element.prototype.matches;
        expect(Element.prototype.matches).toBeUndefined();

        applyPolyfills();
        expect(Element.prototype.matches).toBeDefined();
    });

    it("polyfills Element.closest", () => {
        const MockElement = Object.getPrototypeOf(Element);
        delete MockElement.prototype.closest;
        delete Element.prototype.closest;
        expect(Element.prototype.closest).toBeUndefined();

        applyPolyfills();
        expect(Element.prototype.closest).toBeDefined();
        const div = document.createElement("div");
        const span = document.createElement("span");
        div.appendChild(span);
        expect(Element.prototype.closest.call(span, "div")).toEqual(div);
        expect(Element.prototype.closest.call(span, "html")).toEqual(null);
    });
});
